module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_leaf2-eb3781888d9cdc849937d8b757b01d37.png";